import React from 'react'
import { useSetupWizard } from '../../contexts/SetupWizardContext'
import { useThemeColors } from '../../hooks/useThemeColors'
import WizardProgress from './WizardProgress'
import WizardNavigation from './WizardNavigation'
import WelcomeStep from './steps/WelcomeStep'
import OrganizationStep from './steps/OrganizationStep'
import BrandingStep from './steps/BrandingStep'
import FacilitiesStep from './steps/FacilitiesStep'
import ServicesStep from './steps/ServicesStep'
import PackagesStep from './steps/PackagesStep'
import MembershipStep from './steps/MembershipStep'
import ScheduleTemplatesStep from './steps/ScheduleTemplatesStep'
import TeamStep from './steps/TeamStep'
import ReviewStep from './steps/ReviewStep'

export default function SetupWizard() {
  const { currentStep } = useSetupWizard()
  const colors = useThemeColors()

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <WelcomeStep />
      case 1:
        return <OrganizationStep />
      case 2:
        return <BrandingStep />
      case 3:
        return <FacilitiesStep />
      case 4:
        return <ServicesStep />
      case 5:
        return <PackagesStep />
      case 6:
        return <MembershipStep />
      case 7:
        return <ScheduleTemplatesStep />
      case 8:
        return <TeamStep />
      case 9:
        return <ReviewStep />
      default:
        return <WelcomeStep />
    }
  }

  return (
    <div className="setup-wizard" style={{ 
      minHeight: '100vh',
      backgroundColor: colors.background,
      color: colors.text
    }}>
      {/* Header */}
      <div className="wizard-header" style={{
        backgroundColor: colors.backgroundLight,
        borderBottom: `1px solid ${colors.border}`,
        padding: '1rem 2rem',
        position: 'sticky',
        top: 0,
        zIndex: 10
      }}>
        <h1 style={{
          fontSize: '1.5rem',
          fontWeight: '600',
          margin: 0,
          background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryHover} 100%)`,
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Facility Setup Wizard
        </h1>
      </div>

      {/* Progress Bar */}
      {currentStep > 0 && (
        <WizardProgress />
      )}

      {/* Main Content */}
      <div className="wizard-content" style={{
        maxWidth: '1000px',
        margin: '0 auto',
        padding: '2rem'
      }}>
        <div className="step-container" style={{
          backgroundColor: colors.backgroundLight,
          borderRadius: '12px',
          border: `1px solid ${colors.border}`,
          padding: '2rem',
          minHeight: '400px'
        }}>
          {renderStep()}
        </div>

        {/* Navigation */}
        <WizardNavigation />
      </div>

      <style>{`
        .setup-wizard {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .wizard-content {
          animation: fadeIn 0.3s ease-in-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Responsive design */
        @media (max-width: 768px) {
          .wizard-header {
            padding: 1rem !important;
          }

          .wizard-header h1 {
            font-size: 1.25rem !important;
          }

          .wizard-content {
            padding: 1rem !important;
          }

          .step-container {
            padding: 1.5rem !important;
          }
        }
      `}</style>
    </div>
  )
}